import { getHasGlobalFilterDurationChangedFromDefault } from '@modules/dashboard/helpers/getHasGlobalFilterDurationChangedFromDefault';
import { DashboardQuery } from '@modules/dashboard/store/types';
import { QBNode } from 'v2/querybuilder/types/qbNode';

interface GetGlobalFilterCountOptions {
  duration?: DashboardQuery['duration'];
  nodes?: QBNode;
}

export const getGlobalFilterCount = ({
  duration,
  nodes,
}: GetGlobalFilterCountOptions) => {
  const qbNodesCount = nodes?.children?.length ?? 0;
  const durationCount =
    duration && getHasGlobalFilterDurationChangedFromDefault(duration) ? 1 : 0;

  return qbNodesCount + durationCount;
};
